import axios from '../utils/axios'
import qs from 'qs'

const kongUrl=process.env.VUE_APP_KONG_API_URL

export async function verify(){
    return  await axios.post(kongUrl+'/admin/verify');
}

export async function listcate(){
    return await axios.post(kongUrl+'/admin/bg_admin/menu/listcate','ident=pay');
}

export function adminBaseInfo(){
    return axios.get(kongUrl+'/admin/bg_admin/user/base_info');
}


export function saveCollection(params){
    if(params.id==0){
        return axios.post('/api/v1/collection/create',params);
    }else{
        return axios.post('/api/v1/collection/edit/'+params.id,params);
    }
}
export function  listCollection(params){
    return axios.get('/api/v1/collection/list'+params);
}

export function  enableDisableCollection(params){
    if(params.status==0){
        return axios.get('/api/v1/collection/enable/'+params.id,params);
    }else{
        return axios.get('/api/v1/collection/stop/'+params.id,params);
    }
}

export function  selectCollection(){
    return axios.get('/api/v1/collection/listcompany');
}

export function saveProduct(params){
    let data=qs.stringify(params)
    if(params.id==0){
        return axios.post('/api/v1/product/create/'+params.paytype,data);
    }else{
        return axios.post('/api/v1/product/edit/'+params.paytype+'/'+params.id,data);
    }
}

export function getProduct(params){
    return axios.get('/api/v1/product/get/'+params.paytype+"/"+params.productid);
}

export function  listProduct(params){
    return axios.get('/api/v1/product/list'+params);
}

export function  enableDisableProduct(params){
    if(params.paystatus==0){
        return axios.get('/api/v1/product/enable/'+params.paytype+'/'+params.id,params);
    }else{
        return axios.get('/api/v1/product/stop/'+params.paytype+'/'+params.id,params);
    }
}

export function  listRelation(params){
    return axios.get('/api/v1/contract/list'+params);
}

export function saveRelation(params){
    let data=qs.stringify(params)
    if(params.id==0){
        return axios.post('/api/v1/contract/create',data);
    }else{
        return axios.post('/api/v1/contract/edit/'+params.id,data);
    }
}
export function  searchSelectRelation(){
    return axios.get('/api/v1/contract/codeList');
}

export function  listPayLog(params){
    return axios.get('/api/v1/paysuccesslog/list'+params);
}